import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import SEO from "@/components/SEO";

export default function Gallery() {
  const [images, setImages] = useState([]);

  useEffect(() => {
    api.get("/products").then((r) => {
      const all = [];
      r.data.forEach((p) => {
        all.push({ src: p.image_url, name: p.name, category: p.category });
        (p.gallery || []).forEach((g) => all.push({ src: g, name: p.name, category: p.category }));
      });
      // Dedupe
      const seen = new Set();
      const unique = all.filter((x) => (seen.has(x.src) ? false : (seen.add(x.src), true)));
      setImages(unique);
    });
  }, []);

  return (
    <div data-testid="gallery-page" className="max-w-7xl mx-auto px-6 md:px-10 py-16">
      <SEO
        title="Gallery — Our desserts up close"
        description="Photography of every signature Cake World dessert — the way they arrive to hotels, restaurants and cafés."
      />
      <div className="max-w-2xl">
        <div className="eyebrow">Gallery</div>
        <h1 className="font-display text-5xl sm:text-6xl text-brand-ink mt-2 leading-none">A closer look.</h1>
        <p className="mt-6 text-brand-stone leading-relaxed font-ui">
          A collection of our signature desserts — the way they arrive to our hospitality partners across the country.
        </p>
      </div>

      <div className="dot-divider mt-10" />

      <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {images.map((img, i) => (
          <figure
            key={`${img.src}-${i}`}
            data-testid={`gallery-item-${i}`}
            className="rounded-2xl overflow-hidden border border-brand-line shadow-soft bg-brand-pinkSoft"
          >
            <div className="aspect-square overflow-hidden bg-brand-pinkLight">
              <img src={img.src} alt={img.name} className="w-full h-full object-contain p-4 hover:scale-105 transition-transform duration-700 ease-out" loading="lazy" />
            </div>
            <figcaption className="px-4 py-3 bg-white">
              <div className="eyebrow">{img.category}</div>
              <div className="font-display text-lg text-brand-ink mt-1">{img.name}</div>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  );
}
